export default __webpack_public_path__ + "static/a-new-bg-5a5137b5990ddfe1ff8549f14c8cd4ca.jpg";